export const WeightChangeEnum = {
    MAINTAIN: 'maintain',
    LOSS: 'loss',
    GAIN: 'gain',
};
